import { useCallback } from 'react';

/**
 * Image-to-image navigation. The previous picture used to stay on screen and
 * fade out; two different aspect ratios then looked like the image was
 * resizing for the whole fade. Swap immediately instead.
 *
 * @param {Object|Function} navigation - `{ push, replace }` or React Router `navigate`
 * @returns {Object} Navigation function. Fade fields stay empty so overlays never paint.
 */
export const useFadeTransition = (navigation) => {
    const replace = typeof navigation === 'function'
        ? (url) => navigation(url, { replace: true })
        : (url) => navigation.replace(url);

    const navigateWithFade = useCallback((url) => {
        replace(url);
    }, [replace]);

    return {
        fadeOut: null,
        fadeOpacity: 1,
        navigateWithFade,
    };
};

export default useFadeTransition;
